import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enabled: false,
  globalReclaimConfig: {}
};
export const reclaimModeSlice = createSlice({
  name: "reclaimMode",
  initialState,
  reducers: {
    enableReclaimMode: (state) => {
      state.enabled = true;
    },
    updateReclaimModeConfig: (state, action) => {
      state.globalReclaimConfig = action.payload;
    }
  }
});

export const { enableReclaimMode, updateReclaimModeConfig } =
  reclaimModeSlice.actions;
export default reclaimModeSlice.reducer;
